import React from "react";
import { motion } from "framer-motion";
import { alpha, Box, Button, Stack, Typography, useTheme } from "@mui/material";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";

// Delivery provider data
const deliveryProviders = [
  {
    id: "ifood",
    name: "iFood",
    logo: "/images/ifood-easy-delivery.png",
    color: "#EA1D2C",
  },
  {
    id: "uber",
    name: "Uber",
    logo: "/images/uber-logo-small.png",
    color: "#232323",
  },
];

const ShippingProvidersButton = ({
  onClick,
  variant = "contained",
  size = "medium",
  fullWidth = false,
  disabled = false,
  children,
  showLogos = true,
  sx = {},
}) => {
  const theme = useTheme();

  const buttonVariants = {
    hover: {
      scale: 1.02,
      boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
    },
    tap: {
      scale: 0.98,
    },
  };

  const logoVariants = {
    hover: {
      x: [0, -2, 0],
      transition: {
        duration: 0.3,
        ease: "easeInOut",
      },
    },
  };

  return (
    <motion.div
      variants={buttonVariants}
      whileHover="hover"
      whileTap="tap"
      style={{ width: fullWidth ? "100%" : "auto" }}
    >
      <Button
        variant={variant}
        size={size}
        fullWidth={fullWidth}
        disabled={disabled}
        onClick={onClick}
        sx={{
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 600,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          background:
            variant === "contained"
              ? `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`
              : undefined,
          border:
            variant === "outlined"
              ? `1px solid ${alpha(theme.palette.primary.main, 0.3)}`
              : undefined,
          "&:hover": {
            background:
              variant === "contained"
                ? `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`
                : variant === "outlined"
                ? alpha(theme.palette.primary.main, 0.04)
                : undefined,
            boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
          },
          "&:disabled": {
            background: alpha(theme.palette.action.disabled, 0.1),
            boxShadow: "none",
          },
          ...sx,
        }}
      >
        <Stack
          direction="row"
          spacing={showLogos ? 1.5 : 1}
          alignItems="center"
          sx={{ position: "relative", zIndex: 1 }}
        >
          {showLogos && (
            <motion.div variants={logoVariants}>
              <Box
                sx={{
                  position: "relative",
                  width: 60,
                  height: 24,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {deliveryProviders.map((provider, index) => (
                  <Box
                    key={provider.id}
                    sx={{
                      position: "absolute",
                      left: index * 15,
                      width: 24,
                      height: 24,
                      borderRadius: "50%",
                      backgroundColor: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: `0 2px 8px ${alpha(provider.color, 0.3)}`,
                      border: `2px solid white`,
                      zIndex: deliveryProviders.length - index,
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={provider.logo}
                      alt={provider.name}
                      style={{
                        width: "18px",
                        height: "18px",
                        objectFit: "contain",
                        borderRadius: "50%",
                      }}
                    />
                  </Box>
                ))}
              </Box>
            </motion.div>
          )}

          {!showLogos && <DeliveryDiningIcon fontSize="small" />}

          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color:
                variant === "contained" ? "white" : theme.palette.primary.main,
            }}
          >
            {children || "Entregadores Externos"}
          </Typography>
        </Stack>
      </Button>
    </motion.div>
  );
};

export default ShippingProvidersButton;
